/**
 * Default duration for a CTA transition that is not driven by async ops.
 */
export const DEFAULT_CTA_TRANSITION_DURATION = 1200;
